import ScrollToElement from "common/utils/ui/scroll-to-element";

import "./jiffy-made-upsell-card.scss";

const $getJiffyMadeUpsellCard = () => document.querySelector(".js-jiffy-made-upsell-card");

const init = () => {
  const $card = $getJiffyMadeUpsellCard();
  if (!$card) return;

  const { hasJiffyMade } = $card.dataset;

  $card.addEventListener("click", evt => {
    if (!hasJiffyMade) {
      return;
    }

    evt.preventDefault();
    evt.stopPropagation();
    ScrollToElement.scrollIntoViewBySelector(".js-pdp-experience-switcher");
  });
};

export default init;
